function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon/Icon';
import Label from '../label/Label';
import CheckChunkySvg from '../iconography/icons/CheckChunky';

var Checkbox =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Checkbox, _React$PureComponent);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));
    var value = props.value === undefined ? props.defaultValue : Boolean(props.value);
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var value = _ref.value;

      // We explicitly test for undefined for the case when the value is
      // specifically not passed
      if (value !== undefined) {
        this.setState({
          value: Boolean(value)
        });
      }
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          htmlValue = _this$props.htmlValue;
      var value = e.target.checked;
      this.setState({
        value: value
      });

      if (onChange) {
        onChange(value, htmlValue);
      }
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      var _this$props2 = this.props,
          onBlur = _this$props2.onBlur,
          htmlValue = _this$props2.htmlValue;

      if (onBlur) {
        onBlur(this.state.value, htmlValue);
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      var _this$props3 = this.props,
          onFocus = _this$props3.onFocus,
          htmlValue = _this$props3.htmlValue;

      if (onFocus) {
        onFocus(this.state.value, htmlValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          name = _this$props4.name,
          children = _this$props4.children,
          isDisabled = _this$props4.isDisabled,
          htmlValue = _this$props4.htmlValue,
          dataSpec = _this$props4['data-spec'],
          __containerClassName = _this$props4.__containerClassName;
      var value = this.state.value;
      var wrapperClassName = classNames('eds-checkbox', __containerClassName);
      var checkboxLabel;

      if (children) {
        checkboxLabel = React.createElement(Label, {
          className: "eds-checkbox__label",
          htmlFor: id,
          "data-spec": "checkbox-display-label",
          "data-automation": "".concat(id, "-label")
        }, children);
      }

      var dataAutomation = "checkbox-".concat(id);
      return React.createElement("div", {
        className: wrapperClassName
      }, React.createElement("input", {
        id: id,
        type: "checkbox",
        className: "eds-checkbox__input",
        name: name,
        value: htmlValue,
        disabled: isDisabled,
        checked: value,
        "data-spec": dataSpec,
        onChange: this._handleChange.bind(this),
        onBlur: this._handleBlur.bind(this),
        onFocus: this._handleFocus.bind(this),
        "data-automation": dataAutomation
      }), React.createElement(Label, {
        className: "eds-checkbox__label eds-checkbox__delegate eds-text--center",
        htmlFor: id,
        "data-spec": "checkbox-delegate"
      }, React.createElement("div", {
        className: "eds-checkbox__background"
      }), React.createElement("div", {
        className: "eds-checkbox__checkmark"
      }, React.createElement(Icon, {
        type: React.createElement(CheckChunkySvg, null),
        strokeColor: "white"
      })), React.createElement("div", {
        className: "eds-checkbox__foreground"
      })), checkboxLabel);
    }
  }]);

  return Checkbox;
}(React.PureComponent);

_defineProperty(Checkbox, "propTypes", {
  /**
   * ID of checkbox component's wrapper
   */
  id: PropTypes.string.isRequired,

  /**
   * Initial checkbox checked state when it is created.
   * It will not override the state after it's been created.
   */
  defaultValue: PropTypes.bool,

  /**
   * The checkbox's checked state, overriding any existing state.
   */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /**
   * Name of the checkbox
   */
  name: PropTypes.string,

  /**
   * The contents of the checkbox (i.e: its label)
   */
  children: PropTypes.node,

  /**
   * The value of the checkbox
   */
  htmlValue: PropTypes.string,

  /**
   * Value of if the checkbox is disabled
   */
  isDisabled: PropTypes.bool,

  /**
   * Function to be invoked when checkbox checked state changes.
   * Passes the checked state and checkbox value
   */
  onChange: PropTypes.func,

  /**
   * Function To be invoked when checkbox is blurred.
   * Passes the checked state and checkbox value
   */
  onBlur: PropTypes.func,

  /**
   * Function to be invoked when checkbox is focused.
   * Passes the checked state and checkbox value
   */
  onFocus: PropTypes.func,

  /**
   * Identifier for tests
   */
  'data-spec': PropTypes.string,

  /**
   * Class names for checkbox component wrapper
   */
  __containerClassName: PropTypes.string
});

_defineProperty(Checkbox, "defaultProps", {
  defaultValue: false,
  isDisabled: false,
  'data-spec': 'checkbox'
});

export { Checkbox as default };